import { pxtorem } from "@/utils/pxtorem";
import { Dialog } from "antd-mobile";
import React, { useMemo } from "react";
import styles from "./index.module.less";

export interface SubProcessItemProps {
  label: string;
  subLabel?: string;
  desc?: string | React.ReactNode;
  tip?: string;
  topText?: string;
  bottomText?: string;
  // 实际最多三个
  popInfo: {
    topText: string;
    bottomText: string;
    reach: boolean;
  }[];
  valuePopBg: string;
  processBarBg: string;
  percentBg: string;
  targetBg: string;
  percentType?: "line" | "point";
  hasMore?: boolean;
  isHighLightLastPop?: boolean;
  width?: number
}

const fixPoint = new Array(4).fill(1);

export default function SubProcessItem(props: SubProcessItemProps) {
  const { percentType = "line", hasMore = false } = props;
  const width = 282;
  const precentBgWidth = percentType === "line" ? width : 187;
  // 进度条之间的间隔
  const interval = Math.floor(width / props.popInfo.length);
  // 通过判断popInfo中reach为true的个数来计算
  const isAllComplete = props.popInfo.every(item => item.reach);
  const reachCount = props.popInfo.filter(item => item.reach).length;
  const tempWidth = reachCount * interval;
  const percentWidth = isAllComplete ? pxtorem(tempWidth) : pxtorem(tempWidth + 40);
  // 计算小火箭的位置
  const rocketLeft = isAllComplete ? pxtorem(tempWidth - 24) : pxtorem(tempWidth + 20);

  const revPopInfo = useMemo(() => [...props.popInfo.reverse()], [props.popInfo]);
  return (
    <div
      className={styles.processItem}
      style={{ paddingRight: percentType === "line" && hasMore ? 0 : pxtorem(12), width: pxtorem(props.width || 320) }}>
      {/* 标题 */}
      <div
        className={styles.labelWrapper}
        onClick={() => {
          if (!props.tip) {
            return;
          }
          Dialog.alert({
            title: props.label,
            content: props.tip,
            confirmText: "我知道了",
            className: "dialog__private",
          });
        }}>
        <span className={styles.label}>{props.label}</span>
        <span className={styles.subLabel}>{props.subLabel}</span>
        {props.tip && (
          <img
            src="https://akim-oss.aikucun.com/6e598eeeaca220dadb35a83855b54d9752ee582b_1747291275477_20.png"
            className={styles.tipIcon}
          />
        )}
      </div>
      {/* 描述 */}
      {props.desc ? props.desc : null}
      {/* 进度条 */}
      {Array.isArray(props.popInfo) && props.popInfo.length > 0 && (
        <div className={styles.processBarWrapper}>
          {/* 进度条上方文本 */}
          {!!props.topText && <div className={styles.topText}>{props.topText}</div>}
          <div className={styles.processBarTop}>
            {revPopInfo.map((item, index) => {
              const left = pxtorem(width - index * interval);
              if (item.reach) {
                return (
                  <div
                    key={index}
                    style={{ backgroundImage: `url(${props.valuePopBg})`, left }}
                    className={styles.processValue}>
                    {item.topText}
                  </div>
                );
              }
              if (props.isHighLightLastPop && index === 0) {
                return (
                  <div
                    key={index}
                    style={{ left }}
                    className={styles.highLightLastPop}>
                    {item.topText}
                  </div>
                );
              }
              return (
                <div key={index} className={styles.processTargetWrapper} style={{ left }}>
                  <div className={styles.processTarget}>
                    {item.topText}
                    <img
                      src="https://akim-oss.aikucun.com/576196f7d18895bcecce50460d894e80c809dbae_1747365991052_24.png"
                      className={styles.processTargetLock}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={styles.processBar}
            style={{
              paddingTop: pxtorem(30),
              width: percentType === "line" && hasMore ? "100%" : pxtorem(width),
            }}>
            {/* 进度条底图（100%进度） */}
            <div className={styles.processBarBg}>
              {/* 进度条底图 */}
              <div className={styles.percentBgWrapper}>
                <div
                  className={styles.percentBg}
                  style={{
                    backgroundColor: props.processBarBg,
                    width: percentType === "line" && hasMore ? "100%" : pxtorem(precentBgWidth),
                    borderRadius: percentType === "line" && hasMore ? "100px 0 0 100px" : "100px",
                  }}
                />
                {percentType === "point" && (
                  <div className={styles.percentPointBgWrapper}>
                    {/* 另一个部分点状进度条底图 */}
                    {fixPoint.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={styles.percentPointBg}
                          style={{
                            backgroundColor: props.processBarBg,
                          }}
                        />
                      );
                    })}
                  </div>
                )}
                {/* 进度条进度 */}
                <img
                  className={styles.percentWrapper}
                  src={props.percentBg}
                  style={{ width: percentWidth }}
                />
              </div>
              {/* 小火箭 */}
              <div className={styles.precentSuffix} style={{ left: rocketLeft }}></div>
              {!isAllComplete &&
                revPopInfo.map((item, index) => {
                  // 根据长度来计算气泡偏移量
                  const left = pxtorem(width - index * interval);
                  return (
                    <div
                      key={index}
                      className={styles.targetPoint}
                      style={{ backgroundImage: `url(${props.targetBg})`, left }}></div>
                  );
                })}
            </div>
          </div>
          <div className={styles.processBarBottom}>
            {/* 进度条下方文本 */}
            {!!props.bottomText && <div className={styles.bottomText}>{props.bottomText}</div>}
            {revPopInfo.map((item, index) => {
              // 根据长度来计算气泡偏移量
              const left = pxtorem(width - index * interval);
              return (
                <div key={index} className={styles.targetLabel} style={{ left }}>
                  {item.bottomText}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
